import { render, staticRenderFns } from "./CreateUsers.vue?vue&type=template&id=27b0af68&scoped=true&"
import script from "./CreateUsers.vue?vue&type=script&lang=ts&"
export * from "./CreateUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUsers.vue?vue&type=style&index=0&id=27b0af68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0af68",
  null
  
)

export default component.exports